<template>
  <v-card elevation="0" class="text-left" color="teal lighten-5">
    <v-list :color=" highlight ? 'teal lighten-5' : ''" style="cursor: pointer;">
      <v-list-item three-line>
        <v-list-item-avatar>
          <v-icon large :color="claimIcon.color" v-text="claimIcon.icon"></v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title >
            <b>{{ claim ? claim.DOC_NUM : '' }}</b>
            <small> [{{claim ? claim.DOC_STATUS: ''}}]</small>
            <span v-if="haveNewComments(claim)" class="orange--text ml-2"><small>+{{haveNewComments(claim)}} </small></span>
          </v-list-item-title>
          <v-list-item-subtitle>{{ claim ? claim.CR_DATE : '' }}</v-list-item-subtitle>
          <v-list-item-subtitle> {{ claim ? claim.USR_FIO : '' }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>

export default {
  name: 'claimCard',
  props: ['claim', 'mode', 'highlight'],
  components: {
  },
  data: () => ({

  }),
  computed: {
    claimIcon: {
      get: function () {
        if (!this.claim) return { icon: 'mdi-comment-question', color: 'blue-grey lighten-3' }
        switch (this.claim.DT_ID) {
          case '0':
            return { icon: 'mdi-comment-edit', color: 'teal' }
          case '1':
            return { icon: 'mdi-comment-account', color: 'amber darken-3' }
          case '2':
            return { icon: 'mdi-comment-remove', color: 'deep-orange darken-3' }
          default:
            return { icon: 'mdi-comment-question', color: 'blue-grey lighten-3' }
        }
      }
    }
  },
  methods: {
    haveNewComments (item) {
      return item.COMMENTS_TAB.reduce((sum, curr) => (curr.IS_READED || curr.OWN_COMMENT) ? sum : sum + 1, 0)
    }
  }
}
</script>
